import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, XCircle, MinusCircle, ChevronLeft, ChevronRight } from "lucide-react";
import api from "@/lib/api";

const STATUS_META = {
  sent: { icon: CheckCircle2, classes: "text-emerald-400" },
  failed: { icon: XCircle, classes: "text-red-400" },
  skipped: { icon: MinusCircle, classes: "text-slate-400" },
  skipped_not_configured: { icon: MinusCircle, classes: "text-amber-400" },
};

export default function ActivityPanel() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 30;

  useEffect(() => {
    api.get("/admin/crm/activity", { params: { page, limit } })
      .then((r) => { setLogs(r.data.logs); setTotal(r.data.total); })
      .catch(() => toast.error("Could not load activity"));
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <div data-testid="crm-activity-panel">
      <div className="glass-panel rounded-2xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-slate-400 border-b border-white/10">
              <th className="p-3">Date</th><th className="p-3">Campaign</th><th className="p-3">Contact</th><th className="p-3">Channel</th><th className="p-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => {
              const meta = STATUS_META[l.status] || STATUS_META.skipped;
              const Icon = meta.icon;
              return (
                <tr key={l.id} className="border-b border-white/5 last:border-0" data-testid={`crm-activity-row-${l.id}`}>
                  <td className="p-3 text-slate-400 whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="p-3 text-white">{l.campaign_name}</td>
                  <td className="p-3 text-slate-300">{l.contact_email}</td>
                  <td className="p-3 text-slate-400 capitalize">{l.channel}</td>
                  <td className="p-3">
                    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${meta.classes}`}>
                      <Icon className="w-3.5 h-3.5" /> {l.status.replace(/_/g, " ")}
                    </span>
                    {l.error && <p className="text-[10px] text-slate-500 mt-0.5">{l.error}</p>}
                  </td>
                </tr>
              );
            })}
            {logs.length === 0 && (
              <tr><td colSpan={5} className="p-6 text-center text-slate-400 text-sm" data-testid="crm-no-activity">No message activity yet — send your first campaign to see delivery logs here.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      {total > limit && (
        <div className="flex items-center justify-center gap-3 mt-4">
          <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1} data-testid="crm-activity-prev-page"
            className="text-slate-400 hover:text-white disabled:opacity-30"><ChevronLeft className="w-4 h-4" /></button>
          <span className="text-xs text-slate-400">Page {page} of {totalPages}</span>
          <button onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages} data-testid="crm-activity-next-page"
            className="text-slate-400 hover:text-white disabled:opacity-30"><ChevronRight className="w-4 h-4" /></button>
        </div>
      )}
    </div>
  );
}
